<script setup lang="ts">
import { computed, onMounted } from "vue";

// import parseStringPrice from "@/helpers/parseStringPrice";
import WIDGET_ANALYTICS_EVENTS from "@/helpers/widgetAnalyticsEvents/widgetAnalyticsEvents";
import { useAnalytics, useAnalyticsEventTiModel } from "@/hooks/useAnalytics/useAnalytics";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useEvaluationResultStore } from "@/stores/evaluationResult/evaluationResult";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";

import HandedDevice from "../../handedDevice/handedDevice.vue";
import Modal from "../../modal/modal.vue";

onMounted(() => {
    useAnalytics(WIDGET_ANALYTICS_EVENTS.DISCOUNT_RANGE);
});

const TIWStore = useTIWStore();
const ChooseDeviceStore = useChooseDeviceStore();
const EvaluationResultStore = useEvaluationResultStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();

function holdFoundsOnCard() {
    TIWStore.HOLD = true;
    TIWStore.switchStep("successfulEvaluation");
}

function onEditHandler() {
    useStoreResetter();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
}

const devicePrice = computed(() => {
    if (typeof HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale === "object") {
        return HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale?.tradeInSale;
    }

    return HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale;
});

// const biometricVerificationDiscountPrice = computed(() => {
//     return (parseStringPrice(devicePrice.value) / 100) * 70;
// });

// function verificationDocuments() {
//     TIWStore.HOLD = false;
//     TIWStore.switchStep("confirmBelowPrice");
// }
</script>

<template>
    <Modal class="tiw__step__chooseRangeDiscount">
        <template #header>
            <p class="tiw__h2">
                {{ useTranslate("tiw__rangeDiscount__title") }}
            </p>
        </template>
        <HandedDevice
            :device-price="devicePrice"
            :device-chain="ChooseDeviceStore.deviceChain"
            :device-state="HowYouRateDeviceStore.rate"
            :device-preview="ChooseDeviceStore.deviceImagePreview"
            :device-grade="HowYouRateDeviceStore.deviceGrade"
            :device-no-grade="EvaluationResultStore.stateOfEvaluation === 'UNKNOWN'"
            :device-terminated="EvaluationResultStore.stateOfEvaluation === 'TERMINATED'"
            :on-edit="onEditHandler"
        />
        <div class="tiw__step__chooseRangeDiscount__body">
            <div class="tiw__step__chooseRangeDiscount__body__item">
                <p class="tiw__step__chooseRangeDiscount__body__item__title">
                    {{ useTranslate("tiw__discount__100") }}
                </p>
                <p class="tiw__step__chooseRangeDiscount__body__item__price">
                    {{ devicePrice }} {{ HowYouRateDeviceStore.registeringDeviceData.currency }}
                </p>
                <p class="tiw__step__chooseRangeDiscount__body__item__desc">
                    {{ useTranslate("tiw__rangeDiscount__hold__text") }}
                </p>
                <Button color="violet" @click="holdFoundsOnCard">
                    {{ useTranslate("tiw__getDiscount") }}
                </Button>
            </div>
            <!-- <hr
                size="1px"
                color="#D3DCE9"
                class="tiw__step__chooseRangeDiscount__body__item__line"
            /> -->
            <!-- <div class="tiw__step__chooseRangeDiscount__body__item">
                <div class="tiw__step__chooseRangeDiscount__body__item__header">
                    <p class="tiw__step__chooseRangeDiscount__body__item__title">
                        {{ useTranslate("tiw__discount__70") }}
                    </p>
                    <p class="tiw__step__chooseRangeDiscount__body__item__price__percent">
                        {{ biometricVerificationDiscountPrice.toFixed() }}
                        {{ HowYouRateDeviceStore.registeringDeviceData.currency }}
                    </p>
                </div>
                <p class="tiw__step__chooseRangeDiscount__body__item__desc">
                    {{ useTranslate("tiw__rangeDiscount__biometric__text") }}
                </p>
                <div class="tiw__step__chooseRangeDiscount__body__item__actions">
                    <button class="tiw__step__chooseRangeDiscount__back" @click="onBack">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6.47852 3.33325L2.00047 7.99992L6.47852 12.6666"
                                stroke="#808D9A"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <line
                                x1="0.75"
                                y1="-0.75"
                                x2="11.072"
                                y2="-0.75"
                                transform="matrix(1 0 0 -1 2.17773 7.35449)"
                                stroke="#808D9A"
                                stroke-width="1.5"
                                stroke-linecap="round"
                            />
                        </svg>
                        <p>{{ useTranslate("tiw__back") }}</p>
                    </button>
                    <button
                        class="tiw__step__chooseRangeDiscount__body__item__actions__get"
                        @click="verificationDocuments"
                    >
                        {{ useTranslate("tiw__getDiscount") }}
                    </button>
                </div>
            </div> -->
        </div>
    </Modal>
</template>

<style lang="scss" src="./chooseRangeDiscount.scss"></style>
